import React from "react"
import {useTranslation} from "react-i18next"

import {IonButton, IonIcon, useIonAlert} from "@ionic/react"
import {cloudOutline, cloudSharp} from "ionicons/icons"

interface props {
    active?:  boolean
    itemType: string
}


const ListItemButtonDataSource: React.FC<props> = ({ itemType, active }) => {

    const {t} = useTranslation()
        , [presentAlert] = useIonAlert()
        , translationKey: string = "common.alerts." + (active ? 'data_source' : 'no_data_source')

    const alertDataSource = async (e: any) => {
        e.preventDefault()
        e.stopPropagation()

        if (active) {
            return presentAlert({
                header:  t(translationKey + '.header'),
                message: t(translationKey + '.message', { itemType: itemType }),
                buttons: [{
                    text: t('common.cancel'),
                    role: 'cancel'
                }]
            })
        }
    }

    return (
        <IonButton color={active ? 'medium' : 'light'}
                   className={! active ? "ion-page-invisible" : ""}
                   fill="clear"
                   onClick={(e) => alertDataSource(e)}
                   title={t('common.alerts.data_source.header').toString()}>
            <IonIcon slot="icon-only" ios={cloudOutline} md={cloudSharp} />
        </IonButton>
    )
}

export default ListItemButtonDataSource